<button
  type="button"
  class="edit-button"
  [disabled]="disabled"
  (click)="clicked.emit()"
  [class.large]="size === 'large'"
>
  <mat-icon>edit</mat-icon>
</button>
